import React, { useEffect } from "react";
import PanierPage from "../components/panier/PanierPage";
import HomeHeader from "../components/homePage/HomeHeader";
import HomeHeader2 from "@/components/homePage/HomeHeader2";
function Panier({
  acces,
  total,
  setTotal,
  codeP,
  setCodeP,
  panierchg,
  paniernbr,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HomeHeader2 acces={acces} paniernbr={paniernbr} />
      <PanierPage
        acces={acces}
        total={total}
        setTotal={setTotal}
        codeP={codeP}
        setCodeP={setCodeP}
        panierchg={panierchg}
      />
    </>
  );
}

export default Panier;
